function NumberFormatter(num, digits) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
    //   { value: 1e15, symbol: "quadrillion" },
    //   { value: 1e18, symbol: "quintillion" }
  ];
  const rx = /\.0+$|(\.\d*[1-9])0+$/;
  const item = lookup.slice().reverse().find((data) => num >= data.value);
  return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
}

export default NumberFormatter;
